<template>
    <div class="payment-locker-view row align-items-center p-5">

		<div class="col text-center">
			<div class="font-size-5 mb-4">
				Subscribe below<br/> to get instant access to your personal secure portal.
			</div>

			<div class="mb-4 font-size-5"><strong>Amount due: {{currencyFormatted(subscriptionAmount)}}</strong></div>

			<LoadingIndicator v-if="isProgressShowing"/>
			<div v-else-if="errorLoadingPaymentOptions" class="p-3">Oops, something went wrong: can't load payment buttons. Please reload this page or contact support.</div>
			<div v-else-if="hasConnectedAccounts">
				<div class="mb-3" v-if="stripeLoaded">
					<el-button :id="stripeButtonId"
							   :ref="stripeButtonId"
							   type="primary"
							   v-if="!errorLoadingPaymentOptions"
							   @click="onStripeClicked"
							   :loading="isStripeButtonLoading"
							   style="width: 250px; display: inline-block; padding: 9px;">
						Subscribe
					</el-button>
				</div>
				<div :id="payPalButtonId" v-if="paypalLoaded" style="width: 250px; display: inline-block"></div>
			</div>
			<div v-else>
				Seems like your coach haven't added any suitable payment options yet.
				<br/>Please contact your coach to let them know they need to add their billing details.
				<br/>Once your coach completes setting up their billing details, return here to subscribe to the coaching.
			</div>


		</div>
	</div>
</template>

<script>
    import {uuidv4} from "@/utils/helpers";
	import PaymentSdkManager
		from "@/core/modules/coach/Billing/view/PaymentIntegrations/Options/PaymentSdkManager";
	import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
	import LockerState from "@shared/Program/Locaker/LockerState";

	import BaseComponent from "@/core/components/BaseComponent.vue";
	import CoachingProgram from "@shared/Program/CoachingProgram";

	export default {
		extends: BaseComponent,
        name: "SubscribeLockerView",
		components: {LoadingIndicator},
		props:{
        	coachingProgram: CoachingProgram,
		},
		data: () => ({
			paypalButton: null,
        	payPalButtonId: "id" + uuidv4(),
			stripeButtonId: "id" + uuidv4(),
			isStripeButtonLoading: false,
			paymentSdkManager: null,
			stripeLoaded: false,
			paypalLoaded: false,
			stripe: null,
			paypal: null,
			errorLoadingPaymentOptions: false,
			hasConnectedAccounts: false
		}),
		mounted() {
        	this.paymentSdkManager = new PaymentSdkManager(this.$dataManager)
			this.setupPaymentOptions()

		},
		methods: {
        	async setupPaymentOptions(){

        		this.progressDataLoading()


        		try{
					let {stripe, paypal} = await this.$dataManager.apiGetConnectedBillingAccounts({coachId: this.$dataManager.ownerId})
					console.log("stripe = ", stripe, ", paypal = ", paypal)
					await Promise.all([
						stripe ? this.loadStripeSdk().then(_ => this.stripeLoaded = true) : null,
					])
					this.hasConnectedAccounts = this.stripeLoaded || this.paypalLoaded
					this.hideProgress()
				} catch (error) {
					this.errorLoadingPaymentOptions = true
					this.handleError(error)
				}

			},

			async onStripeClicked(){
        		let _ = this.$analyticManager.trackEvent("Subscribe clicked", this.analyticsPropsMethod())
        		this.isStripeButtonLoading = true
				try{
					let requestData = this.createSubscriptionRequest()
					let sessionId = await this.$dataManager.apiPostStripeCreateSubscription(requestData)
					let result = await this.stripe.redirectToCheckout({sessionId})
					if(result && result.error){
						this.handleError(result.error)
						this.isStripeButtonLoading = false
					}
				} catch (error) {
					this.handleError(error)
					this.isStripeButtonLoading = false
				}
			},
			async loadStripeSdk(){
				this.stripe = await this.paymentSdkManager.loadStripeSdk()
			},



			createSubscriptionRequest(){
        		return {
					clientId: this.userProfile.id,
					coachId: this.ownerProfile.id,
					programId: this.coachingProgram.id,
					redirectUrl: this.getBrandedLink(window.location.href)
				}
			},



			analyticsPropsInternal(){
        		return {
        			label: "Subscription started locker"
				}
			}
		},

		computed: {
			recurringBillingItem() {
				return this.coachingProgram.recurringBillingItem
			},

			subscriptionAmount(){
				let billing = this.recurringBillingItem
				let oneTimeFee = billing.hasSetupFee ? billing.setupFeeAmount : 0
				return billing.recurringAmount + oneTimeFee
			}
		},
	}
</script>

<style lang="scss">
	.payment-locker-view{
		min-height: 300px;

	}

</style>
